"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class Coupon {
  static thaw(couponObj) {
    if (couponObj == null) return null;
    const coupon = new Coupon();
    if (couponObj.id != null) coupon.setId(couponObj.id);
    if (couponObj.use != null) coupon.setUse(couponObj.use);
    if (couponObj.maxUseCount != null) coupon.setMaxUseCount(couponObj.maxUseCount);
    if (couponObj.currentUseCount != null) coupon.setCurrentUseCount(couponObj.currentUseCount);
    if (couponObj.code != null) coupon.setCode(couponObj.code);
    if (couponObj.segmentId != null) coupon.setSegmentId(couponObj.segmentId);
    if (couponObj.ergonarId != null) coupon.setErgonarId(couponObj.ergonarId);
    if (couponObj.segment != null) coupon.setSegment(_.ErgoAlgoSegment.thaw(couponObj.segment));
    if (couponObj.ergonar != null) coupon.setErgonar(_.Ergonar.thaw(couponObj.ergonar));
    if (couponObj.transactions != null) coupon.setTransactions(_.Transaction.thawList(couponObj.transactions));
    if (couponObj.percentOff != null) coupon.setPercentOff(couponObj.percentOff);
    if (couponObj.amountOff != null) coupon.setAmountOff(couponObj.amountOff);
    if (couponObj.isActive != null) coupon.setIsActive(couponObj.isActive);
    return coupon;
  }

  static thawList(couponObjList) {
    if (couponObjList == null) return [];
    var coupons = [];

    for (var i = 0; i < couponObjList.length; i++) {
      coupons.push(Coupon.thaw(couponObjList[i]));
    }

    return coupons;
  }

  static freeze(coupon) {
    if (coupon == null) return null;
    var couponObj = {};
    if (coupon.getId() != null) couponObj.id = coupon.getId();
    if (coupon.getUse() != null) couponObj.use = coupon.getUse();
    if (coupon.getMaxUseCount() != null) couponObj.maxUseCount = coupon.getMaxUseCount();
    if (coupon.getCurrentUseCount() != null) couponObj.currentUseCount = coupon.getCurrentUseCount();
    if (coupon.getCode() != null) couponObj.code = coupon.getCode();
    if (coupon.getSegmentId() != null) couponObj.segmentId = coupon.getSegmentId();
    if (coupon.getErgonarId() != null) couponObj.ergonarId = coupon.getErgonarId();
    if (coupon.getSegment() != null) couponObj.segment = _.ErgoAlgoSegment.freeze(coupon.getSegment());
    if (coupon.getErgonar() != null) couponObj.ergonar = _.Ergonar.freeze(coupon.getErgonar());
    if (coupon.getTransactions() != null) couponObj.transactions = _.Transaction.freezeList(coupon.getTransactions());
    if (coupon.getPercentOff() != null) couponObj.percentOff = coupon.getPercentOff();
    if (coupon.getAmountOff() != null) couponObj.amountOff = coupon.getAmountOff();
    if (coupon.getIsActive() != null) couponObj.isActive = coupon.getIsActive();
    return couponObj;
  }

  static freezeList(coupons) {
    if (coupons == null) return [];
    var couponObjList = [];

    for (var i = 0; i < coupons.length; i++) {
      couponObjList.push(Coupon.freeze(coupons[i]));
    }

    return couponObjList;
  }

  constructor() {
    this.setId(null);
    this.setUse(null);
    this.setMaxUseCount(null);
    this.setCurrentUseCount(null);
    this.setCode(null);
    this.setSegmentId(null);
    this.setErgonarId(null);
    this.setSegment(null);
    this.setErgonar(null);
    this.setTransactions(null);
    this.setPercentOff(null);
    this.setAmountOff(null);
    this.setIsActive(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setUse(use) {
    this.use = use;
  }

  setMaxUseCount(maxUseCount) {
    this.maxUseCount = maxUseCount;
  }

  setCurrentUseCount(currentUseCount) {
    this.currentUseCount = currentUseCount;
  }

  setCode(code) {
    this.code = code;
  }

  setSegmentId(segmentId) {
    this.segmentId = segmentId;
  }

  setErgonarId(ergonarId) {
    this.ergonarId = ergonarId;
  }

  setSegment(segment) {
    this.segment = segment;
  }

  setErgonar(ergonar) {
    this.ergonar = ergonar;
  }

  setTransactions(transactions) {
    this.transactions = transactions;
  }

  setPercentOff(percentOff) {
    this.percentOff = percentOff;
  }

  setAmountOff(amountOff) {
    this.amountOff = amountOff;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getUse() {
    return this.use;
  }

  getMaxUseCount() {
    return this.maxUseCount;
  }

  getCurrentUseCount() {
    return this.currentUseCount;
  }

  getCode() {
    return this.code;
  }

  getSegmentId() {
    return this.segmentId;
  }

  getErgonarId() {
    return this.ergonarId;
  }

  getSegment() {
    return this.segment;
  }

  getErgonar() {
    return this.ergonar;
  }

  getTransactions() {
    return this.transactions;
  }

  getPercentOff() {
    return this.percentOff;
  }

  getAmountOff() {
    return this.amountOff;
  }

  getIsActive() {
    return this.isActive;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = Coupon;